import styled from "styled-components";

export const Container = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 72px 40px 80px;

  @media (max-width: 768px) {
    padding: 56px 24px 64px;
  }
`;

export const BackgroundImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

export const Inner = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1100px;
  width: 100%;
`;

export const SectionTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  margin: 0 0 56px 0;

  @media (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 40px;
  }
`;

export const CirclesRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 48px;
  width: 100%;

  @media (max-width: 900px) {
    gap: 32px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 32px;
  }
`;

export const CircleStep = styled.div`
  width: 260px;
  height: 260px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px 28px;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 900px) {
    width: 220px;
    height: 220px;
    padding: 24px 20px;
  }

  @media (max-width: 768px) {
    width: 240px;
    height: 240px;
    padding: 28px 24px;
  }
`;

export const StepNumber = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
`;

export const StepTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 12px 0;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`;

export const StepDesc = styled.p`
  font-family: 'Aileron', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  line-height: 1.55;

  @media (max-width: 900px) {
    font-size: 13px;
  }
`;

export const GetStartedButton = styled.button`
  margin-top: 52px;
  background-color: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 28px;
  padding: 13px 44px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }

  @media (max-width: 768px) {
    margin-top: 40px;
    font-size: 15px;
    padding: 12px 36px;
  }
`;
